import axios from "axios";

export const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000/api/v1", headers: { Accept: "application/json" } });

export const imageUrl = (path) => {
  if (!path) return null;
  if (/^https?:\/\//.test(path)) return path;
  const apiRoot = (process.env.REACT_APP_API_URL || "http://localhost:8000/api/v1").replace(/\/api\/v1\/?$/, "");
  return `${apiRoot}/storage/${path}`;
};
